export default "__VITE_ASSET__2721f1cf__"